import { observer } from 'mobx-react';
import { localeStore } from 'src/mobx/localesStore';
import { TBooleanInNumber } from 'src/types/main';
import { booleanToNumber, stringTransform } from 'src/utils/helpers';
import { floatNumbersValidation } from 'src/utils/validation';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import Input from 'src/view/components/Controls/Input/Input';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import branchEditStore from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/store/branchEditStore';
import Text from '~/view/components/Text/Text';

const PaymentSwitchers = observer(() => {
  const onChangePreSelectStatus = (status: TBooleanInNumber) => {
    branchEditStore.changeBranchData({ pre_select_default: !!status });
  };

  const onChangeAllMethodsStatus = (status: TBooleanInNumber) => {
    branchEditStore.changeBranchData({ allow_all_payment_methods: status });
  };

  const onChangeCashMaxLimitStatus = (status: TBooleanInNumber) => {
    branchEditStore.changeBranchData({ is_max_cash_payment: status });
  };

  const onChangeCashMaxLimitValue = (value: string) => {
    const formattedValue = stringTransform(value);

    if (floatNumbersValidation(formattedValue, 1) && formattedValue !== '0') {
      branchEditStore.changeMaxCashPayment(formattedValue);
    }
  };

  return (
    <div className="d-flex flex-column gap-30">
      <div className="d-flex align-items-center">
        <Switcher status={booleanToNumber(branchEditStore.editableBranch.pre_select_default)} onChange={onChangePreSelectStatus} />
        <Text
          type="switcher-label"
          text="preselect_branch_default_payment_method_toggle"
          tooltip={{
            message: 'preselect_branch_default_payment_method_tooltip',
            position: TOOLTIP_POSITION.FIXED,
            duration: TOOLTIP_DURATION.EXTRA_LARGE,
            iconSize: 24,
          }}
        />
      </div>

      <div className="d-flex align-items-center">
        <Switcher status={branchEditStore.editableBranch.allow_all_payment_methods} onChange={onChangeAllMethodsStatus} />
        <Text
          type="switcher-label"
          text="enable_all_payment_methods_for_cca"
          tooltip={{
            message: 'enable_all_payment_methods_for_cca_tooltip',
            position: TOOLTIP_POSITION.FIXED,
            duration: TOOLTIP_DURATION.EXTRA_LARGE,
            iconSize: 24,
          }}
        />
      </div>
      {branchEditStore.editableBranch.is_max_cash_payment_hidden ? null : (
        <>
          <div className="d-flex align-items-center">
            <Switcher status={booleanToNumber(branchEditStore.editableBranch.is_max_cash_payment)} onChange={onChangeCashMaxLimitStatus} />
            <Text type="switcher-label" text="max_limit_on_cash_payment_toggle" />
          </div>

          {branchEditStore.editableBranch.is_max_cash_payment ? (
            <Input
              value={branchEditStore.maxCashPayment}
              placeholder={localeStore.t('type_in_max_cash_limit')}
              className="input input-mini w-50 family-medium text-size-16"
              onChangeText={onChangeCashMaxLimitValue}
            />
          ) : null}
        </>
      )}
    </div>
  );
});

export default PaymentSwitchers;
